import { SlidersHorizontal } from "lucide-react";

export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center px-4">
      <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
        <SlidersHorizontal className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="text-base font-semibold mb-1">No posts found</h3>
      <p className="text-sm text-muted-foreground max-w-sm">
        Try changing your filters or check back later for new content.
      </p>
    </div>
  );
}
